import React, { FC } from 'react';
import { ReactComponent as OSLogo } from '../../assets/svg/OS_logo.svg';
import { ExternalLink } from '../../components/ExternalLink';

export const PrivacyPolicy: FC = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p>We care about your privacy, that’s why we don’t collect any of your data. </p>
      <p>
        We do however rely on third-party platforms and services. We use the Graph and selected wallets. Some of your
        data might therefore be subject to their respective privacy policies.
      </p>
      <p>Find out more here:</p>
      <p>
        The Graph -{' '}
        <a target="_blank" rel="noreferrer" href="https://thegraph.com/privacy/">
          https://thegraph.com/privacy/
        </a>
      </p>
      <p>
        MetaMask -{' '}
        <a target="_blank" rel="noreferrer" href="https://consensys.net/privacy-policy/">
          https://consensys.net/privacy-policy/
        </a>
      </p>
      <p>
        Coinbase -{' '}
        <a target="_blank" rel="noreferrer" href="https://www.coinbase.com/legal/privacy">
          https://www.coinbase.com/legal/privacy
        </a>
      </p>
      <p>
        Fortmatic -{' '}
        <a target="_blank" rel="noreferrer" href="https://fortmatic.com/legal/developer-privacy-policy/">
          https://fortmatic.com/legal/developer-privacy-policy/
        </a>
      </p>
      <p>For a more anonymous browsing experience we recommend using a VPN.</p>

      <p className="opensea">
        Information about NFTs is provided by opensea API 💛{' '}
        <ExternalLink href="https://opensea.io/">
          <OSLogo className="opensea-logo clickEffect" />
        </ExternalLink>
      </p>
    </div>
  );
};
